import React from 'react';
import { DomainNs } from 'ReactApp/Types/DomainNs';
import { observer } from "mobx-react";
import { ProductCardDetailLevelEnum, ShowableCartSourceModeEnum } from 'ReactApp/Types/enum';
import ProductCardV7 from 'ReactApp/Components/ProductCardV7/ProductCardV7';
import ProductCardV6 from 'ReactApp/Components/ProductCardV6/ProductCardV6';
import { ShowableCart } from 'ReactApp/Ddd/Aggregates/ShowableCart';

type CartProductListV1Props = {
    showableCart: ShowableCart
}

const CartProductListV1 = observer((props: CartProductListV1Props) => {

    return (
        <div className="product-list-v1">
            {props.showableCart.cards.map((card, index) => {
                if (card.detailLevel === ProductCardDetailLevelEnum.l7) {
                    return (
                        <ProductCardV7 key={`pcv7-${index}`} {...{
                            card: (card as DomainNs.ProductCardV7Interface),
                            cardIndex: index,
                            isReadonlyMode: (props.showableCart.sourceMode === ShowableCartSourceModeEnum.order)
                        }} />
                    );
                } else if (card.detailLevel === ProductCardDetailLevelEnum.l6) {
                    return (
                        <ProductCardV6 key={`pcv6-${index}`} {...{
                            card: (card as DomainNs.ProductCardV6Interface),
                            cardIndex: index,
                            isReadonlyMode: (props.showableCart.sourceMode === ShowableCartSourceModeEnum.order)
                        }} />
                    );
                }
            })}
        </div>
    );

})

export default CartProductListV1;